module.exports = __webpack_public_path__ + "static/media/program1.44799fdd.webp";